import {
  createWorkBadgePresignedUploadUrlRequestSchema,
  createWorkBadgePresignedUploadUrlResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { API_TYPES, post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import axios from "axios";

interface UploadWorkBadgePdfParams {
  workerId: string;
  qualification: string;
  pdfBlob: Blob;
}

async function fetchWorkBadgePresignedUploadUrl(workerId: string, qualification: string) {
  const response = await post({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/work-badge-presigned-upload-urls`,
    data: {
      data: {
        type: API_TYPES.workBadgePresignedUploadUrl,
        attributes: {
          qualification,
        },
      },
    },
    requestSchema: createWorkBadgePresignedUploadUrlRequestSchema,
    responseSchema: createWorkBadgePresignedUploadUrlResponseSchema,
  });

  return response.data;
}

export function useUploadWorkBadgePdf(
  options: UseMutationOptions<string, Error, UploadWorkBadgePdfParams> = {}
) {
  return useMutation({
    mutationFn: async ({ workerId, qualification, pdfBlob }) => {
      const { data } = await fetchWorkBadgePresignedUploadUrl(workerId, qualification);
      const { presignedUrl, fileKey } = data.attributes;

      await axios.put(presignedUrl, pdfBlob, {
        headers: { "Content-Type": "application/pdf" },
      });

      return fileKey;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.WORK_BADGE_PDF_UPLOAD_FAILURE,
    },
    ...options,
  });
}
